<template>
  <div>
    <div v-for="(item, index) in optionList" :key="index">
      <a-tag v-if="optionVal === item.id" :color="getColor(index)" :class="statusStyle">
        <complete-icon v-if="icon === 'complete'" />
        <processing-icon v-if="icon === 'processing'" />
        <ClockCircleOutlined  v-if="icon === 'waiting'" />
        {{ item.name }}
      </a-tag>
    </div>
  </div>
</template>

<script>
import ProcessingIcon from "@/components/public/processingIcon.vue";
import CompleteIcon from "@/components/public/completeIcon.vue";
import {ClockCircleOutlined} from '@ant-design/icons-vue'

export default {
  name: "optionTag",
  components: { CompleteIcon, ProcessingIcon, ClockCircleOutlined },
  props : {
    optionVal : String,
    optionList : Array,
    icon: String,
  },
  data(){
    return{
      color : ["pink","red", "orange", "green", "cyan", "blue"],
      language: 'zh'
    }
  },
  mounted() {
    this.language = localStorage.getItem('local')||'zh';
  },
  methods : {
    getColor(index){
      if (this.icon === "complete"){
        return "green"
      }
      if (this.icon === "processing"){
        return "orange"
      }
      if (this.icon === "waiting"){
        return ""
      }
      return this.color[index % 6]
    }
  },
  computed: {
    statusStyle(){
      if(!this.icon){
        return ""
      }
      if (this.language === "zh"){
        return "zh-style"
      }else {
        return "en-style"
      }
    }
  }
}
</script>

<style scoped>
.en-style {
  width: 154px;
  text-align: left
}
.zh-style{
  width: 79px;
  text-align: left
}
</style>